import {Component, OnInit} from '@angular/core';
import {DeploymentsService} from "../deployments.service";
import {DataService} from "../data.service";
import {ActivatedRoute, Router} from "@angular/router";
import * as moment from 'moment';
import {TimezoneService} from "../timezone.service";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
    selector: 'app-data-plot',
    templateUrl: './data-plot.component.html',
    styleUrls: ['./data-plot.component.scss']
})
export class DataPlotComponent implements OnInit {

    deploymentNumber: number;

    missions: any = null;
    erddapMetadata: any = null;
    selectedMetadata: { delayed: { id: string, variables: string[] } | null, realtime: { id: string, variables: string[] } | null };
    variables: string[] = ['temperature', 'salinity', 'density'];
    missionHasData: any = null;
    selectedMission: any = null;
    selectedDatasetType: 'Delayed' | 'Realtime' | null;

    moment: any = moment;
    timezone: any = null;
    missionStart: any = null;
    missionEnd: any = null;

    graphVariable: string | null;
    graphPeriod: 'week' | 'day' | 'hour' = 'week';
    graphData: string | null = null;

    graphStartTime: any = null;
    graphEndTime: any = null;
    validRange: boolean | null = null;

    constructor(
        private deploymentsService: DeploymentsService,
        private dataService: DataService,
        private route: ActivatedRoute,
        private router: Router,
        private spinner: NgxSpinnerService,
        private timezoneService: TimezoneService) {
        this.timezone = timezoneService.timezone;
    }

    ngOnInit() {
        this.deploymentsService.getAllDeployments().then(response => {
            this.missions = response.sort((a, b) => b.deployment_number - a.deployment_number);
            this.deploymentsService.getMetadata().then(response => {
                this.erddapMetadata = response;
                this.loadMission();
            });
        });

        this.deploymentNumber = parseInt(this.route.snapshot.params['deploymentNumber']);
    }

    loadMission() {
        this.graphData = null;
        this.graphVariable = null;
        this.selectedDatasetType = null;

        if (!this.deploymentNumber) {
            this.selectedMission = null;
            return;
        }

        this.selectedMission = Array.getByProperty(this.missions, this.deploymentNumber, 'deployment_number');

        if (this.selectedMission) {
            this.selectedMetadata = this.erddapMetadata[this.deploymentNumber];
            this.missionHasData = this.selectedMetadata.delayed || this.selectedMetadata.realtime;
            // if realtime is available, select it, otherwise select delayed
            if (this.selectedMetadata.realtime) {
                this.selectedDatasetType = 'Realtime';
            } else if (this.selectedMetadata.delayed) {
                this.selectedDatasetType = 'Delayed';
            }

            this.missionStart = moment(this.selectedMission.start_time).format('YYYY-MM-DD');
            if (this.selectedMission.end_time) {
                this.missionEnd = moment(this.selectedMission.end_time).format('YYYY-MM-DD');
            } else {
                this.missionEnd = moment().format('YYYY-MM-DD');
            }
        }

    }

    checkDateRange(){
        if (this.graphStartTime && this.graphEndTime) {
            if (this.graphStartTime >= this.missionStart && this.graphEndTime <= this.missionEnd && this.graphStartTime <= this.graphEndTime) {
                this.validRange = true;
            } else {
                this.validRange = false;
            }
        }
    }

    graph() {
        if (this.selectedDatasetType && this.graphVariable && this.validRange) {
            let dataset: string;

            if (this.selectedDatasetType == 'Delayed' &&  this.selectedMetadata.delayed) {
                dataset = this.selectedMetadata.delayed.id;
            } else if (this.selectedDatasetType == 'Realtime' && this.selectedMetadata.realtime) {
                dataset = this.selectedMetadata.realtime.id;
            } else {
                throw ReferenceError('Selected dataset type is unavailable');
            }

            //edit seconds for repeated calls to not get cached graphs
            let endTime: any = moment(this.graphEndTime).add({hour:23, minute:59, second:0});

            //re-format for dataService
            endTime = moment(endTime).format('YYYY-MM-DD HH:mm:ss');
            let startTime = moment(this.graphStartTime).format('YYYY-MM-DD HH:mm:ss');

            $('.graph-image').show();
            this.spinner.show('spinner-graph');

            // // Timings
            //let t0 = performance.now();

            //this.dataService.graph(dataset, 'sci_water_depth', this.graphVariable, 'true', undefined, endTime, startTime).then(result => {
            this.dataService.graph(dataset, this.graphVariable, undefined, "true",
                undefined, endTime, startTime).then(result => {
                this.spinner.hide('spinner-graph');
                this.graphData = result.toString();
            });
        }
    }
}